import _ from "lodash";

/**
 * Flattens an object
 * @param {Record<string, unknown>} obj
 * @returns {Record<string, unknown>}
 */
export const flatten = (obj: Record<string, unknown>): Record<string, unknown> => {
  const result: Record<string, unknown> = {};

  const flatten = (current: unknown, prefix = ""): void => {
    if (_.isObject(current) && !_.isDate(current) && !_.isRegExp(current) && !_.isFunction(current)) {
      if (_.isArray(current)) {
        _.forEach(current, (value, index) => {
          if (value !== undefined) {
            flatten(value, `${prefix}[${index}]`);
          }
        });
      } else {
        _.forEach(current, (value, key) => {
          if (value !== undefined) {
            const newPrefix = prefix ? `${prefix}.${key}` : key;

            flatten(value, newPrefix);
          }
        });
      }
    } else if (current !== undefined) {
      result[prefix] = current;
    }
  };

  flatten(obj);

  return result;
};

/**
 * Reconstructs a flattened object
 * @param {Record<string, unknown>} flat
 * @returns {Record<string, unknown>}
 */
export const reconstruct = (flat: Record<string, unknown>): Record<string, unknown> => {
  const result: Record<string, unknown> = {};

  _.forEach(flat, (value, path) => {
    if (value !== undefined) {
      _.set(result, path, value);
    }
  });

  return result;
};
